import { HorizontalSection } from '@/components/display/horizontal-section';
import RestaurantCard from '@/components/display/restaurant-card';
import RestaurantCardSkeleton from '@/components/display/restaurant-card-skeleton';
import { Restaurant } from '@/types/display';
import React from 'react';

interface RestaurantSectionProps {
  title: string;
  restaurants: Restaurant[];
  isLoading: boolean;
  onSeeAll?: () => void;
}

const SKELETON_KEYS = ['s1', 's2', 's3'];

export function RestaurantSection({ title, restaurants, isLoading, onSeeAll }: RestaurantSectionProps) {
  if (!isLoading && restaurants.length === 0) return null;

  return (
    <HorizontalSection
      title={title}
      {...(onSeeAll ? { onActionPress: onSeeAll, actionText: 'See All' } : {})}
    >
      {isLoading
        ? SKELETON_KEYS.map((key) => <RestaurantCardSkeleton key={key} />)
        : restaurants.map((restaurant) => (
            <RestaurantCard key={restaurant.id} restaurant={restaurant} />
          ))}
    </HorizontalSection>
  );
}
